/**
 * Каталог тарифов подписки (ориентир для UI).
 * После смены цен на проде выполните scripts/back-update-subscription-plans.sql на ветке back.
 */
export const BASE_PLAN_PRICE_RUB = 7500
export const BASE_PLAN_MONTHLY_TOKENS = 10000
export const BASE_RATE_RUB_PER_TOKEN = BASE_PLAN_PRICE_RUB / BASE_PLAN_MONTHLY_TOKENS

export const SUBSCRIPTION_PLANS = [
  {
    slug: 'starter',
    name: 'Базовый',
    price_rub: 7500,
    monthly_tokens: 10000,
    tagline: 'Старт для небольшого потока закупок',
    description: 'Поиск, анализ рисков и разбор ТЗ — 10 000 токенов в месяц.',
    bullets: [
      'Поиск и агрегация закупок РФ и Казахстана',
      'Риски, критерии и чат по документации',
      '10 000 токенов в месяц',
    ],
    highlighted: false,
    showReferencePrice: false,
  },
  {
    slug: 'pro',
    name: 'Средний',
    price_rub: 14000,
    monthly_tokens: 20000,
    tagline: 'Для десятков закупок параллельно',
    description: 'Расширенный тариф для активного потока закупок.',
    bullets: [
      'Все модули Базового',
      '20 000 токенов в месяц',
      'Выгоднее по сравнению с базовым ₽/токен',
    ],
    highlighted: true,
    showReferencePrice: true,
  },
  {
    slug: 'enterprise',
    name: 'PRO',
    price_rub: 27000,
    monthly_tokens: 40000,
    tagline: 'Максимальный объём для команды',
    description: 'Тариф PRO для высокой нагрузки и нескольких направлений закупок.',
    bullets: [
      'Все модули Среднего',
      '40 000 токенов в месяц',
      'Лучшая цена токена среди планов',
    ],
    highlighted: false,
    showReferencePrice: true,
  },
]

/** Пробный доступ (не SubscriptionPlan в БД). */
export const TRIAL_PLAN_DISPLAY = {
  slug: 'trial',
  name: 'Пробный',
  trialDays: 7,
  trialTokens: 1500,
  priceWasRub: BASE_PLAN_PRICE_RUB,
  price_rub: 0,
  tagline: 'Попробуйте на своих закупках',
  description: '7 дней и 1 500 токенов после подтверждения e-mail.',
  bullets: [
    'Полный доступ к поиску и анализу',
    '1 500 токенов на тест',
    'Без оплаты при регистрации',
  ],
}

/** Корпоративный — условия по запросу. */
export const CORPORATE_PLAN_DISPLAY = {
  slug: 'corporate',
  name: 'Корпоративный',
  contactEmail: 'Ai@neyrosvet.ru',
  tagline: 'Для команд и филиалов',
  description: 'Индивидуальные лимиты, оплата и внедрение — по договорённости.',
  bullets: [
    'Персональный объём токенов',
    'Счёт и договор',
    'Сопровождение внедрения',
  ],
}

export function referencePriceFromBase(monthlyTokens) {
  return Math.ceil((monthlyTokens * BASE_PLAN_PRICE_RUB) / BASE_PLAN_MONTHLY_TOKENS)
}

const catalogBySlug = Object.fromEntries(SUBSCRIPTION_PLANS.map((p) => [p.slug, p]))

function mergePlanWithCatalog(plan) {
  if (!plan?.slug) return plan
  const cat = catalogBySlug[plan.slug]
  if (!cat) return plan
  return {
    ...plan,
    name: cat.name,
    description: cat.description ?? plan.description,
    price_rub: cat.price_rub,
    monthly_tokens: cat.monthly_tokens,
  }
}

/** Подставляет актуальные цены/лимиты в ответ GET /billing/plans/ для отображения в ЛК. */
export function applySubscriptionPlanCatalog(plans) {
  if (!Array.isArray(plans)) return []
  return plans.map(mergePlanWithCatalog)
}

/** Текущий тариф в кошельке (GET /billing/wallet/). */
export function applySubscriptionPlanToWallet(wallet) {
  if (!wallet || typeof wallet !== 'object') return wallet
  if (!wallet.subscription_plan) return wallet
  return {
    ...wallet,
    subscription_plan: mergePlanWithCatalog(wallet.subscription_plan),
  }
}
